import * as React from "react";
import {
  useListContext,
  useGetList,
  usePermissions,
  Admin,
  useGetIdentity,
} from "react-admin";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { useUnselectAll } from 'react-admin'
import { checkModuleAccess, isSuperAdmin } from "../../../Functions/permissions";
import { JSONTree } from "react-json-tree";
import InboxTabScroller from "./InboxTabScroller";


export default function MainFilterAdmin(props) {
  const navigate = useNavigate();
const {permissions} =usePermissions();
const { data: identity } = useGetIdentity();
  const { displayedFilters, filterValues, setFilters, hideFilter, resource, setSort } =
    useListContext();

  const { data: dashboardQueueCounts } = useGetList("getdashboardqueuecounts");
  const dashboardQueueCount = dashboardQueueCounts?.[0];
  const { total: getatsqueueTotal } = useGetList("getatsqueue");
  const ref = React.useRef<null | HTMLInputElement>(null);
  const getFocusToSearch = () => {
    ref.current?.focus();
  };
  const keydownHandler = (e) => {
    if ((e.key === "k" || e.key === "K") && e.ctrlKey) {
      e.preventDefault();
      getFocusToSearch();
    }
  };
  React.useEffect(() => {
    document.addEventListener("keydown", keydownHandler);
    return () => {
      document.removeEventListener("keydown", keydownHandler);
    };
  }, []);
  const filterForm = useForm<any>({
    defaultValues: {
      lastApplicationInDays: [{ label: `Last 30 Days`, value: 30 }],
    },
  });

  React.useEffect(() => {
    if (
      filterValues?.lastApplicationInDays &&
      filterForm.getValues("lastApplicationInDays")?.value !==
      filterValues?.lastApplicationInDays
    ) {
      filterForm.setValue("lastApplicationInDays", [
        {
          label: `Last ${filterValues?.lastApplicationInDays} Days`,
          value: filterValues?.lastApplicationInDays,
        },
      ]);
    }
  }, [filterValues]);

  const previousInboxType = React.useRef<string | undefined>(undefined);

  // Apply Screening default sort only when entering the tab, not on every render.
  React.useEffect(() => {
    const currentInboxType = filterValues?.inbox_type;
    if (
      currentInboxType === "ATS_SCREENING_QUEUE" &&
      previousInboxType.current !== "ATS_SCREENING_QUEUE"
    ) {
      setSort({ field: "LastSubmittedAt", order: "DESC" });
    }
    previousInboxType.current = currentInboxType;
  }, [filterValues?.inbox_type]);


  const unselectAll = useUnselectAll(resource);
  return (
    <InboxTabScroller>
      <div className="app-option-btn" id="a-oprtions">
        {/* <JSONTree data={permissions}/> */}
       {/* <JSONTree data={isSuperAdmin(checkModuleAccess(permissions,"Dashboard","Doc Analysis Review Queue"),identity?.userrole )}/> */}
        {isSuperAdmin(checkModuleAccess(permissions,"Dashboard","Doc Analysis Review Queue"),identity?.userrole ) && <label htmlFor="c3">
          <input type="radio" defaultChecked={'DA_REVIEW_QUEUE' == filterValues.inbox_type || !filterValues.inbox_type } onClick={() => {
            // navigate('/ATS')
            //defaultChecked={'/ats' == location.pathname.toLowerCase()}
            // add filter here in place of direct redirecting to /ats
            setFilters({ 'app_invitation_type': 2, "dashboardOption": 1, "inbox_type": "DA_REVIEW_QUEUE" }, ['app_invitation_type', 'dashboardOption', 'inbox_type']);
            unselectAll();
          }
          }
            name="a-oprtions" id="c3" />
          <span>
            DA QA Review
            {dashboardQueueCount?.reviewQueueCount ? <div className="total_count">{dashboardQueueCount.reviewQueueCount}</div> : <div className="total_count">0</div>}
          </span>
        </label>}
        <label htmlFor="c1">
          <input type="radio" defaultChecked={(filterValues.inbox_type == "ATS_LAST_30_DAYS" )} onClick={() => {
            // navigate('/Ats/Admin/lastapp')
            // defaultChecked={'/Ats/Admin/lastapp'.toLowerCase() == location.pathname.toLowerCase()}
            // add filter here in place of direct redirecting to /Ats/Admin/lastapp
            setFilters({ 'app_invitation_type': "1", "dashboardOption": 1, "inbox_type": "ATS_LAST_30_DAYS" }, ['app_invitation_type', 'dashboardOption', 'inbox_type']);
            unselectAll();
          }} name="a-oprtions" id="c1" />
          <span>
            ATS Last 30 Days
            {dashboardQueueCount?.atsLastThirtyDaysCount ? <div className="total_count">{dashboardQueueCount.atsLastThirtyDaysCount}</div> : <div className="total_count">0</div>}
          </span>
        </label>
        <label htmlFor="c2">
          <input type="radio" defaultChecked={filterValues.inbox_type == "DOCUPLOAD_LAST_30_DAYS"} onClick={() => {
            // defaultChecked={'/Ats/Admin/lastdoc'.toLowerCase() == location.pathname.toLowerCase()}
            // navigate('/Ats/Admin/lastdoc')
            // add filter here in place of direct redirecting to /Ats/Admin/lastdoc
            setFilters({ 'app_invitation_type': 2, "dashboardOption": 1, "inbox_type": "DOCUPLOAD_LAST_30_DAYS" }, ['app_invitation_type', 'dashboardOption', 'inbox_type']);
            unselectAll();
          }} name="a-oprtions" id="c2" />
          <span>
            DA Last 30 Days
            {dashboardQueueCount?.docUploadLastThirtyDaysCount ? <div className="total_count">
              {dashboardQueueCount.docUploadLastThirtyDaysCount}</div> : <div className="total_count">0</div>}
          </span>
        </label>
        {isSuperAdmin(checkModuleAccess(permissions,"Dashboard","ATSQueue"),identity?.userrole ) &&<label htmlFor="c4">
          <input type="radio" defaultChecked={filterValues.inbox_type == "ATS_SCREENING_QUEUE"} onClick={() => {
            // navigate('/Ats/Admin/getatsqueue')
            // defaultChecked={'/Ats/Admin/getatsqueue'.toLowerCase() == location.pathname.toLowerCase()}
            // add filter here in place of direct redirecting to /Ats/Admin/getatsqueue
            setFilters({ 'app_invitation_type': 1, "dashboardOption": 1, "inbox_type": "ATS_SCREENING_QUEUE" }, ['app_invitation_type', 'dashboardOption', 'inbox_type']);
            setSort({ field: "LastSubmittedAt", order: "DESC" });
            unselectAll();
          }} name="a-oprtions" id="c4" />
          <span>
            Screening 
            {getatsqueueTotal ? <div className="total_count">
              {getatsqueueTotal ? getatsqueueTotal : " "}</div> : <div className="total_count">0</div>}

          </span>
        </label>}

      </div>
    </InboxTabScroller>
  );
}
